/* /src/styles/HeroSection.jsx */

import React from 'react';
import '../styles/HeroSection.css';
import logo from '../assets/skilt-technical-logo.png';
import heroImage from '../assets/hero-graphic.png';

const HeroSection = () => {
  return (
    <section className="hero">
      <div className="logo-container">
        <img src={logo} alt="Skilt Logo" className="logo-icon" />
        <span className="logo-text">Skilt Technical</span>
      </div>
      <div className="hero-content">
        <h1>Wo Fachwissen auf digitale Lösungen trifft</h1>
        <div className="hero-image">
          <img src={heroImage} alt="Technische Anlage" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;

